export default "__VITE_ASSET__zOtv_q2b__"